<template>
  <div>
    <b-container fluid class="p-2">
      <b-row>
        <b-col lg="6" md="6" sm="12">
          <h3>دسته بندی</h3>
        </b-col>
        <b-col lg="6" md="6" sm="12" class="text-left">

          <router-link :to="{ name: 'TrashCategory' }">
            <b-button pill variant="danger" class="mr-2">
              سطل زباله
            </b-button>
          </router-link>

          <b-button
              v-if="templateType !== 'trash'"
              pill
              variant="purple"
              v-b-toggle.create-new-category
          >دسته بندی جدید
          </b-button>

          <router-link :to="{ name: 'Category' }" v-else>
            <b-button pill variant="purple">دسته بندی ها</b-button>
          </router-link>

          <LanguageSelectBox v-if="templateType !== 'trash'" @changeLanguage="emitToParent" module-name="category"
                             class="mx-4 d-inline-block"/>

        </b-col>
      </b-row>
      <b-collapse id="create-new-category" class="mt-2">
        <Category mode="create" class="border border-5"/>
      </b-collapse>


      <slot></slot>
    </b-container>
  </div>
</template>

<script>
import Category from './Category'
import LanguageSelectBox from "../../../components/dashboard/Language/LanguageSelectBox";

export default {
  name: "CategoryLayout",
  components: {Category, LanguageSelectBox},
  props: ["templateType"],
  methods: {
    emitToParent() {
      this.$emit('changeLanguage', true)
    }
  }
};
</script>

<style scoped>
</style>